// DetailedResultsListening.tsx
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../Hooks/use-store';
import ReadingReport from './ReadingReport';
import Tabs from '../ieltsResultsTabs/Tabs';

const DetailedResultsListening: React.FC = () => {
  const { resultsStoreListening } = useStore();
  const { individualTestScorePart1, individualTestScorePart2, individualTestScorePart3, individualTestScorePart4, partType } = resultsStoreListening;

  const tabs = [
    { label: 'Part 1', content: <ReadingReport partDetails={individualTestScorePart1} /> },
    { label: 'Part 2', content: <ReadingReport partDetails={individualTestScorePart2} /> },
    { label: 'Part 3', content: <ReadingReport partDetails={individualTestScorePart3} /> },
    { label: 'Part 4', content: <ReadingReport partDetails={individualTestScorePart4} /> },
  ];

  return (
    <div className="bg-[#E3E5E9]-500 border-2 rounded-[8px] w-[90%]">
      <header>
        <Tabs tabs={tabs} partType={partType} />
      </header>
    </div>
  );
};

export default observer(DetailedResultsListening);
